"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getDefaultState() {
    return {
        ui: {
            currentTab: 'default',
        },
    };
}
exports.getDefaultState = getDefaultState;
//# sourceMappingURL=state.js.map